jQuery(function($)
{
  initNavHero();

  function initNavHero() {
    if ($('.fl-row.hero-section').length == 0) {
      $('.global-nav').addClass('no-hero');
    }
  }
});
